import { maskDecimal } from '@givebutter/util';
import { ContactType } from 'constants/contacts';
import { getContactNameDisplay } from 'customHooks/contactNameDisplay';
import {
    LinkableCampaign,
    LinkableContact,
    LinkableTicket,
    LinkableTransaction,
    TaskLinkable,
} from 'types/domain';

const LinkedResourceText = ({
    type,
    linkable,
}: {
    type: TaskLinkable['linkable_type'];
    linkable: TaskLinkable['linkable'];
}) => {
    switch (type) {
        case 'contact': {
            if (linkable === null) return '[deleted contact]';
            const { company_name, type } = linkable as LinkableContact;
            const name_display = getContactNameDisplay(linkable as LinkableContact);
            return type === ContactType.Company ? company_name : name_display;
        }
        case 'ticket': {
            if (linkable === null) return '[deleted ticket]';
            const { uid_suffix } = linkable as LinkableTicket;
            return `Ticket ${uid_suffix}`;
        }
        case 'transaction': {
            if (linkable === null) return '[deleted transaction]';
            const { amount, contact } = linkable as LinkableTransaction;
            const contactName =
                contact?.type === ContactType.Company
                    ? contact.company_name
                    : `${contact?.first_name} ${contact?.last_name}`;
            return `$${maskDecimal(amount)} from ${contactName}`;
        }
        case 'campaign': {
            if (linkable === null) return '[deleted campaign]';
            const { title } = linkable as LinkableCampaign;
            return title;
        }
    }
};

export { LinkedResourceText };
